import Default from './default';

class Products extends Default {
	namespace = 'products';

	beforeEnter = data => {
		super.beforeEnter(data);

		const nextContainer = data.next.container;

		const $accordions = $(nextContainer).find('.accordion');
		if ($accordions.length) {
			import('bootstrap/js/dist/collapse').then(() => {
				console.log('accordion imported');
			});
		}
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};
}

export default new Products();
